import { FC, ReactNode } from 'react';

import { HELP_PAGE_RULES_URL } from 'utils/constants/app';

import { VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { Banner } from 'components/common/MagritteBannerPreviewSidebar/Banner/Banner';
import defaultImage from 'components/common/MagritteBannerPreviewSidebar/BannerPreviewSection/images/defaultImage.png';
import { HelpPageLink } from 'components/common/MagritteBannerPreviewSidebar/HelpPageLink/HelpPage';
import { SectionHeader } from 'components/common/MagritteBannerPreviewSidebar/SectionHeader/SectionHeader';

interface BannerPreviewSectionProps {
    title: string;
    text: string;
    image?: string;
    bannerImageBadge?: ReactNode;
    vacancyId?: number | null;
}

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerPreview.title',
    subtitle: 'AdCreate.AdForm.BannerPreview.subtitle',
    rules: 'AdCreate.AdForm.BannerPreview.rules',
};

export const BannerPreviewSection: FC<BannerPreviewSectionProps> = ({
    title,
    text,
    image,
    bannerImageBadge,
    vacancyId,
}) => {
    const trls = useTrls();

    return (
        <VSpacingContainer default={20}>
            <SectionHeader title={trls(TrlKeys.title)} subtitle={trls(TrlKeys.subtitle)} />
            <Banner title={title} text={text} image={image || defaultImage} bannerImageBadge={bannerImageBadge} />
            <HelpPageLink url={HELP_PAGE_RULES_URL} text={trls(TrlKeys.rules)} vacancyId={vacancyId} />
        </VSpacingContainer>
    );
};
